import React, { Fragment, useContext } from 'react'
import InfoContext from '../../context/info/infoContext'
import Preloaders from '../Preloaders/Preloaders'
import EducationItem from './EducationItem'
import SkillItem from './SkillItem'
import Intro from './Intro'
import JourneyItem from './JourneyItem'
import HeaderHome from './HeaderHome'
import Footer from '../Footer'

const Home = () => {

    const infoContext = useContext(InfoContext);

    const { intro, skills, education, loading, journey } = infoContext;

    if(loading){
      return <Preloaders />
    }

    return (
        <Fragment>
    
    <HeaderHome />

    <section id="home-a" className="text-center py-2">
      <div className="container">
        <h1 className="l-heading">I Specialize In</h1>

        <Intro intro={intro}/>

        <div className="specials my-3">
          { skills && skills.map(skill => <SkillItem key={skill._id} skill={skill}/>) }
        </div>
      </div>
    </section>

    <section id="home-b" className="text-center">
        <div className="achievements">
        { education && education.map(edu => <EducationItem key={edu._id} edu={edu} />) }
        </div>
    </section>

    <section id="home-c" className="py-2 text-center">
      <div className="container">
        <h1>My JS Journey</h1>
        <div className="bottom-line"></div>
        { intro && intro.map(intro => <p className='lead' key={intro._id}>
            { intro.journey }
          </p>) }
          
        <div className="process">
          { journey && journey.map(j => <JourneyItem journey={j} key={j._id
          }/>) }
        </div>
      </div>
    </section>
    <Footer />
        </Fragment>
    )
}

export default Home
